<template>
  <div @click="handleClick">
    <slot name="action-scroll" :item="{ blank: isBlank, path: pathParsed }" />
  </div>
</template>

<script>
export default {
  props: {
    blank: {
      type: Boolean,
      required: true
    },
    path: {
      type: String,
      default: ''
    },
    anchorIdTarget: {
      type: String,
      default: ''
    },
    openModal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isBlank() {
      return !this.openModal && !this.anchorIdTarget ? this.blank : false;
    },
    pathParsed() {
      return this.openModal ? '' : this.anchorIdTarget ? this.anchorIdTarget : this.path;
    }
  },
  methods: {
    handleClick() {
      if (this.openModal) {
        this.$bvModal.show(this.path);
      } else if (this.anchorIdTarget) {
        const options = {
          offset: -50
        };
        this.$scrollTo(this.anchorIdTarget, 500, options);
      }
      this.$emit('click');
    }
  }
};
</script>
